import Lottie from 'lottie-react';
import { Center } from '@/ui';
import hourglassAnimation from './hourglass.lottie.json';
import mascotAnimation from './mascot.lottie.json';

type AnimationType = 'hourglass' | 'mascot';

type Props = {
  animation: AnimationType;
  size: number;
};

const animations: Record<AnimationType, unknown> = {
  hourglass: hourglassAnimation,
  mascot: mascotAnimation,
};

export const Animation = ({
  animation = 'hourglass',
  size = 100,
}: Props): JSX.Element => {
  return (
    <Center pointerEvents="none">
      <Lottie
        animationData={animations[animation]}
        autoplay
        loop
        style={{ height: size, width: size }}
      />
    </Center>
  );
};
